import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Terms() {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const linkMap = {
        us: {
            email: 'mailto:support@ecoflow.com',
            warrantyPolicy: 'https://us.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://us.ecoflow.com/pages/ecoflow-return-policy',
        },
        ca: {
            email: 'mailto:support@ecoflow.com',
            warrantyPolicy: 'https://ca.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://ca.ecoflow.com/pages/return-refund-policy',
        },
        au: {
            email: 'mailto:support.au@ecoflow.com',
            warrantyPolicy: 'https://au.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://au.ecoflow.com/pages/return-refund-policy',
        },
        eu: {
            email: 'mailto:support.eu@ecoflow.com',
            warrantyPolicy: 'https://eu.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://eu.ecoflow.com/pages/return-refund-policy',
        },
        uk: {
            email: 'mailto:support.eu@ecoflow.com',
            warrantyPolicy: 'https://uk.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://uk.ecoflow.com/pages/return-refund-policy',
        },
        de: {
            email: 'mailto:support.eu@ecoflow.com',
            warrantyPolicy: 'https://de.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://de.ecoflow.com/pages/return-refund-policy',
        },
        fr: {
            email: 'mailto:support.eu@ecoflow.com',
            warrantyPolicy: 'https://fr.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://fr.ecoflow.com/pages/return-refund-policy',
        },
        kr: {
            email: 'mailto:support.kr@ecoflow.com',
            warrantyPolicy: 'https://kr.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://kr.ecoflow.com/policies/refund-policy',
        },
        jp: {
            email: 'mailto:support.jp@ecoflow.com',
            warrantyPolicy: 'https://jp.ecoflow.com/pages/warranty-policy',
            returnPolicy: 'https://jp.ecoflow.com/pages/online-store-policy',
        },
    };

    return (
        <div className={`terms ${css.terms}`}>
            <p className="title">{t('presale.product.terms_title')}</p>
            <p className="content">
                {locale !== 'cn' &&
                    t.rich('presale.product.terms_content', {
                        line1: (child: any) => <a href={linkMap[locale].email}>{child}</a>,
                        line2: (child: any) => <Link href={linkMap[locale].warrantyPolicy}>{child}</Link>,
                        line3: (child: any) => <Link href={linkMap[locale].returnPolicy}>{child}</Link>,
                    })}
                {locale === 'cn' && t('presale.product.terms_content')}
            </p>
        </div>
    );
}
